import { Routes, Route } from "react-router-dom";

import PublicLayout from "../../layouts/PublicLayout/PublicLayout";
import HomePublic from "../../components/Public/HomePublic/HomePublic";
import ServicesPublic from "./../../components/Public/ServicesPublic/ServicesPublic";
import MenuPublic from "../../components/Public/MenuPublic/MenuPublic";
import GalleryPublic from "../../components/Public/GalleryPublic/GalleryPublic";
import NotFoundPage from "./../../components/Page/NotFoundPage/NotFoundPage";

const PublicContainer = () => {
  return (
    <PublicLayout>
      <Routes>
        {/* Home */}
        <Route index element={<HomePublic />} />
        {/* Services */}
        <Route path="/services" element={<ServicesPublic />} />
        {/* Menu */}
        <Route path="/menu" element={<MenuPublic />} />
        {/* Gallery */}
        <Route path="/gallery" element={<GalleryPublic />} />
        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </PublicLayout>
  );
};

export default PublicContainer;
